import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuthorization } from 'framework/authorization';
import { AddressableViewLayout } from 'framework/ViewTypes';
import {
  POSITION_PROFILE_DEPRECATE,
  POSITION_PROFILE_REACTIVATE,
  POSITION_PROFILE_RETIRE,
  POSITION_PROFILE_TIMELINE_ENTRY_CREATE,
  POSITION_PROFILE_TIMELINE_LIST_READ_LIST,
  POSITION_PROFILE_UPDATE,
} from '../constants';
import { PositionProfileFormDrawer } from '../createupdate';
import usePositionProfilesService from '../usePositionProfilesService';
import PositionProfileDetailsContent from './details/PositionProfileDetailsContent';
import usePositionProfileDetails from './model/usePositionProfileDetails';
import { POSITION_SLOT_LIST_READ } from 'domain/people/positionSlots/preview/constants';

const PositionProfileDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const { isGranted } = useAuthorization();
  const { profile, isLoading, error, reload } = usePositionProfileDetails(id);
  const { deprecate, reactivate, retire } = usePositionProfilesService();
  const [isEditDrawerOpen, setEditDrawerOpen] = useState(false);

  const changeStatus = async (action: (profileId: string) => ReturnType<typeof deprecate>) => {
    if (!profile) return;
    await action(profile.id);
    await reload();
  };

  return (
    <AddressableViewLayout
      loading={isLoading}
      contentLayout={
        <PositionProfileDetailsContent
          profile={profile}
          loading={isLoading}
          error={error}
          retry={reload}
          onEdit={() => setEditDrawerOpen(true)}
          onDeprecate={() => changeStatus(deprecate)}
          onReactivate={() => changeStatus(reactivate)}
          onRetire={() => changeStatus(retire)}
          permissions={{
            canUpdate: isGranted(POSITION_PROFILE_UPDATE),
            canDeprecate: isGranted(POSITION_PROFILE_DEPRECATE),
            canReactivate: isGranted(POSITION_PROFILE_REACTIVATE),
            canRetire: isGranted(POSITION_PROFILE_RETIRE),
            canCreateTimelineEntry: isGranted(POSITION_PROFILE_TIMELINE_ENTRY_CREATE),
            canReadTimeline: isGranted(POSITION_PROFILE_TIMELINE_LIST_READ_LIST),
            canReadPositions: isGranted(POSITION_SLOT_LIST_READ),
          }}
        />
      }
      drawer={
        <PositionProfileFormDrawer
          isOpen={isEditDrawerOpen}
          onClose={() => setEditDrawerOpen(false)}
          profile={profile}
          onSuccess={() => reload()}
        />
      }
    />
  );
};

export default PositionProfileDetailsPage;
